<div class="container tam-form-field">
    <div class="tam-form-label label-area" [title]="config.field.fieldDefinition.type">
        <field-label [label]="config.field.fieldDefinition.name" [tooltip]="config.field.fieldDefinition.description"
            [isRequired]="config.required" labelClassList="field-name body-3 text-ellipsis"></field-label>
    </div>
    <div class="tam-textbox" *ngIf="config.editable">
        <input class="tam-textbox" type="number" *ngIf="config.field.fieldDefinition.type==='number'"
            [(ngModel)]="config.field.value" (keyup)="onValueChange($event)" />
        <input class="tam-textbox" type="text" *ngIf="config.field.fieldDefinition.type==='text'"
            [(ngModel)]="config.field.value" (keyup)="onValueChange($event)" />
        <input class="tam-textbox" type="number" *ngIf="config.field.fieldDefinition.type==='currency'"
            [(ngModel)]="config.field.value" (keyup)="onValueChange($event)" />
        <tam-file-upload *ngIf="config.field.fieldDefinition.type==='file'" [config]="config.fileFieldConfig">
        </tam-file-upload>
    </div>
    <div class="field-value body-2" *ngIf="!config.editable&&config.field.fieldDefinition.type==='number'">
        {{config.field.value|currency:'CAD':'symbol-narrow':'1.0-0'}}
    </div>
    <div class="field-value body-2" *ngIf="!config.editable&&config.field.fieldDefinition.type==='text'">
        {{config.field.value}}
    </div>
    <div class="field-value body-2" *ngIf="!config.editable&&config.field.fieldDefinition.type==='currency'">
        {{config.field.value|currency:'CAD':'symbol-narrow':'1.0-0'}}
    </div>
    <tam-file-info class="field-value body-2" *ngIf="!config.editable&&config.field.fieldDefinition.type==='file'"
        [config]="config.field.value">
    </tam-file-info>
</div>